var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.6611,
    cy: 12.2427,
    r: 9.375,
    fill: "#FCFFFD",
    stroke: "#1B1A1B",
    strokeWidth: 1.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_19374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0647 16.9609L14.7939 12.0767",
    stroke: "#1B1A1B",
    strokeWidth: 1.58629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0647 7.19218L14.7939 12.0764",
    stroke: "#1B1A1B",
    strokeWidth: 1.58629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_19374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.77778,
    height: 16,
    fill: "white",
    transform: "translate(7.88965 4.24268)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrowRight);
export default __webpack_public_path__ + "static/media/circle-arrow-right.8d50ff91fbb5d69dffc5b254ee46ad41.svg";
export { ForwardRef as ReactComponent };